import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapSelectOption = React.lazy(function () { return import('../../bootstrap-components/components/BTSelectOption'); });
var BootStrapAsyncSelectOption = React.lazy(function () { return import('../../bootstrap-components/components/BTAsyncSelectOption'); });
var bootStrapSelectOption = function (props) {
    return (React.createElement(BootStrapSelectOption, __assign({ styleName: props.hasError ? 'danger' : props.styleName }, props)));
};
var bootStrapAsyncSelectOption = function (props) {
    return (React.createElement(BootStrapAsyncSelectOption, __assign({ styleName: props.hasError ? 'danger' : props.styleName }, props)));
};
export var SelectOption = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = props.isAsyncOption ? bootStrapAsyncSelectOption(props) : bootStrapSelectOption(props);
            break;
        default:
            componentToDisplay = props.isAsyncOption ? bootStrapAsyncSelectOption(props) : bootStrapSelectOption(props);
            break;
    }
    return (React.createElement("div", null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
SelectOption.defaultProps = {
    styleName: 'primary',
    label: 'SelectOption',
    ioTheme: themes[0],
    ioMode: 'light',
    options: [],
    isInlineGridComponent: false,
    autoFocus: false,
    isDefaultEditable: false,
    isMulti: false,
    isAsyncOption: false
};
//# sourceMappingURL=SelectOption.js.map